import SnapshotDialog from './SnapshotDialog';

export default SnapshotDialog;
